/**
 * A utility function to recursively remove `__typename` keys from object.
 *
 * WARNING: This will destroy any values that can't be JSON stringified, like
 * `file` objects, so don't use it blindly on everything.
 */
export default function stripTypename<T>(
  obj: T,
): T extends ReadonlyArray<infer U> ? T & ReadonlyArray<U> : Omit<T, '__typename'> {
  return JSON.parse(JSON.stringify(obj), (k, v) => (k === '__typename' ? undefined : v))
}
